import React from 'react';
import '../css/Loading.css';

export default class Loading extends React.Component {
  render() {
    return <span className="loading-span">Carregando...</span>;
  }
}
